var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = /^([a-gA-G])?(#{1,}|♯{1,}|b{1,}|♭{1,})?([0-9]+)*$/;
exports = exports["default"];
export default exports;